import { Button } from "@mui/material";
import React from "react";
import { string, object, func } from "prop-types";

type OutlinedButtonProps = React.ComponentProps<typeof Button>;

export const OutlinedButton = (props: OutlinedButtonProps) => {
  const sx = {
    // backgroundColor: "common.black",
    color: "common.black",
    borderColor: "grey.200",
    borderRadius: 1,
    // py: 1,
    // px: 3,
  };

  // console.log(props);

  return (
    <Button
      {...props}
      variant="outlined"
      sx={{
        ...sx,
        ...props.sx,
      }}
      // onClick={props.onClick}
    >
      {props.children}
    </Button>
  );
};

OutlinedButton.propTypes = {
  children: string,
  sx: object,
  onClick: func,
};
